export const FreshdeskLogo = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="34" height="34" rx="3.5" stroke="#05050D" strokeOpacity="0.05" />
      <path
        d="M18.0039 8C13.6712 8 10.1587 11.512 10.1587 15.8452V21.1795C10.1897 22.6074 11.3397 23.7573 12.7675 23.7884H14.9866V17.6606H11.9886V15.9475C12.1706 12.7214 14.8404 10.1977 18.0724 10.1977C21.3044 10.1977 23.9678 12.7165 24.1498 15.9475V17.6606H21.109V23.7926H23.1139V23.8901C23.0925 25.2146 22.0245 26.2832 20.7048 26.2992H18.3101C18.1152 26.2992 17.9011 26.3966 17.9011 26.591C17.9058 26.6979 17.9504 26.7993 18.0261 26.875C18.1018 26.9507 18.2032 26.9953 18.3101 27H20.7192C22.4351 26.9893 23.8233 25.6011 23.834 23.8853V23.6904C24.4071 23.5613 24.9187 23.2397 25.2835 22.7792C25.6483 22.3188 25.8443 21.7472 25.8389 21.1597V15.9475C25.9363 11.5286 22.4319 8.00482 17.9937 8.00482L18.0039 8Z"
        fill="#05050D"
      />
    </svg>
  );
};
